<template>
  <div v-if="address">
    <fp-select
      label="Ország"
      v-model="address.CountryId"
      @change="changeValue"
      :items="eesztCountryList"
      valueKey="EntryId"
      textKey="HungarianName"
      :searchable="true"
      @search="searchCountry"
    />
    <fp-input
      label="Irányítószám"
      description="EESZT felküldéshez kötelező mező!"
      v-model="address.PostalCode"
      @change="changeValue"
    />
    <fp-input
      label="Város"
      description="EESZT felküldéshez kötelező mező!"
      v-model="address.City"
      @change="changeValue"
    />
    <fp-input
      label="Utca, közterület"
      description="EESZT felküldéshez kötelező mező!"
      v-model="address.StreetAddress"
      @change="changeValue"
    />
  </div>
</template>
<script>
import { BaseDataLogic } from "../../../../Logic/Backend/base-data";
export default {
  name: "CreatePatientAddress",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: Object,
  },
  data() {
    return {
      address: null,
      defaultAddress: {
        CountryId: null,
        PostalCode: null,
        City: null,
        StreetAddress: null,
      },

      eesztCountryList: null,
    };
  },
  watch: {
    value() {
      this.setAddressData();
    },
  },
  computed: {
    hasAddressData() {
      return Object.values(this.address).some(
        (x) => x !== null && x !== undefined && x !== ""
      );
    },
  },
  methods: {
    changeValue() {
      if (this.hasAddressData) {
        this.$emit("change", this.address);
      } else {
        this.$emit("change", null);
      }
    },
    setAddressData() {
      if (this.value) {
        this.address = this.value;
      } else {
        this.address = JSON.parse(JSON.stringify(this.defaultAddress));
      }
    },
    async searchCountry(input) {
      if (input && input != "") {
        if (input.length > 2) {
          await this.setList({ ["HungarianName-contains"]: input });
        } else {
          this.eesztCountryList = [];
        }
      } else {
        await this.setList({ "-orderby": "HungarianName", ["-limit"]: 10 });
      }
    },
    async setList(params) {
      this.eesztCountryList = await this.getBase(params);
      if (
        this.address.CountryId &&
        !this.eesztCountryList.find((e) => e.EntryId == this.address.CountryId)
      ) {
        const selectedValue = await this.getBase({
          EntryId: this.address.CountryId,
        });
        if (selectedValue) {
          this.eesztCountryList.push(selectedValue[0]);
        }
      }
      this.eesztCountryList.splice(0, 0, {
        HungarianName: "Nincs megadva",
        EntryId: null,
      });
    },
    async getBase(params) {
      const getBaseResponse = await BaseDataLogic.getBaseData(
        this.$enums.BaseName.eeszt_country.Value,
        params
      );
      if (!getBaseResponse.Code) {
        getBaseResponse.sort((a, b) =>
          a.HungarianName.localeCompare(b.HungarianName)
        );
        return getBaseResponse;
      } else {
        return [
          {
            EntryId: null,
            Name: "Hiba történt a lista lekérdezése során",
          },
        ];
      }
    },
  },
  async mounted() {
    this.setAddressData();
    await this.setList({ "-orderby": "HungarianName", ["-limit"]: 10 });
  },
};
</script>
